import React from 'react';
import { Form, Input, InputNumber, Select, Button, Space } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';

const NOTIFICATION_METHODS = [
  'Email',
  'Web Portal',
  'SMS',
  'Phone Call',
  'Letter',
  'Other'
];

const TIME_UNITS = [
  { label: 'Minutes', value: 'minutes' },
  { label: 'Hours', value: 'hours' },
  { label: 'Days', value: 'days' }
];

export default function RegulatoryRules({ form }) {
  return (
    <div>
      <Form.List name="regulatoryRules">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <div key={key} style={{ marginBottom: 24, padding: 16, border: '1px solid #f0f0f0', borderRadius: 4 }}>
                <Space direction="vertical" style={{ width: '100%' }}>
                  <Form.Item
                    {...restField}
                    name={[name, 'trigger']}
                    label="Trigger"
                    rules={[{ required: true, message: 'Please enter trigger' }]}
                    tooltip="What event triggers this notification (e.g., cyber breach, data loss)"
                  >
                    <Input placeholder="Trigger (e.g., cyber breach)" />
                  </Form.Item>

                  <Form.Item
                    label="Deadline"
                    tooltip="Time to notify after trigger"
                    required
                  >
                    <Space.Compact style={{ width: '100%', display: 'flex' }}>
                      <Form.Item
                        {...restField}
                        name={[name, 'deadlineValue']}
                        rules={[{ required: true, message: 'Please enter deadline value' }]}
                        style={{ flex: 2, marginBottom: 0 }}
                      >
                        <InputNumber
                          min={1}
                          placeholder="Enter value"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'deadlineUnit']}
                        rules={[{ required: true, message: 'Please select time unit' }]}
                        style={{ flex: 1, marginBottom: 0 }}
                      >
                        <Select placeholder="Select unit">
                          {TIME_UNITS.map(unit => (
                            <Select.Option key={unit.value} value={unit.value}>
                              {unit.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, 'regulator']}
                    label="Regulator"
                    rules={[{ required: true, message: 'Please enter regulator' }]}
                    tooltip="Who needs to be notified (e.g., ACSC, Board, Client)"
                  >
                    <Input placeholder="Regulator (e.g., ACSC, Board)" />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, 'method']}
                    label="Method"
                    rules={[{ required: true, message: 'Please select at least one notification method' }]}
                    tooltip="How the notification should be delivered"
                  >
                    <Select
                      mode="multiple"
                      placeholder="Select notification methods"
                      style={{ width: '100%' }}
                    >
                      {NOTIFICATION_METHODS.map(method => (
                        <Select.Option key={method} value={method}>
                          {method}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, 'sender']}
                    label="Sender"
                    rules={[{ required: true, message: 'Please enter sender' }]}
                    tooltip="Who should send the notification (e.g., CISO, CEO)"
                  >
                    <Input placeholder="Sender (e.g., CISO)" />
                  </Form.Item>

                  <Button 
                    type="text" 
                    danger 
                    onClick={() => remove(name)} 
                    icon={<MinusCircleOutlined />}
                  >
                    Remove Rule
                  </Button>
                </Space>
              </div>
            ))}

            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                Add Regulatory Rule
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </div>
  );
} 